import { Outlet } from "react-router-dom";
import { AccountSidebar } from "./AccountSidebar";

/**
 * Layout for the transaction register pages (/transactions, /accounts/:id):
 * renders the minimal Actual-style account picker sidebar beside the page.
 */
export function AccountScopedLayout() {
  return (
    <div className="flex items-start">
      <AccountSidebar />
      <div className="flex-1 min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
